<div class="playground-container">
  @if (playgroundService.playgroundResultStatus === 'resultPresent' && rows.length > 0) {
  <div class="playground-table-wrapper">
    <div class="playground-table">
      <ngx-datatable class="material" [rows]="rows" [columns]="columns" [columnMode]="ColumnMode.force"
        [headerHeight]="50" [footerHeight]="50" [rowHeight]="rowHeight" headerClass="is-gender" [scrollbarV]="true"
        [scrollbarH]="true" [reorderable]="true" [trackByProp]="'contactId'" (reorder)="onColumnReorder($event)">

        <ngx-datatable-column name="#" [width]="60" [maxWidth]="200">
          <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <div class="row-index">
              {{ rowIndex + 1 }}
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column *ngFor="let col of columns; trackBy: trackByFn; index as idx" [name]="col.name ?? ''"
          [width]="col.prop === 'topics' ? 640 : 320" [prop]="col?.prop ?? ''" [sortable]="true" [canAutoResize]="true"
          (columnReorder)="onColumnReorder($event)">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div [class.loading-cell]="row.isLoading">
              <ng-container *ngIf="!row.isLoading">
                <ng-container
                  *ngIf="col.prop === 'topics' || col.prop === 'topicCluster' || col.prop === 'topicsClustered'">
                  <div class="topics-wrapper">
                    @for (topic of row[col.prop]; track topic) {
                    <div class="topic-chip">{{ topic }}</div>
                    }
                  </div>
                </ng-container>
                <ng-container *ngIf="col.prop === 'sentimentAtStart' || col.prop === 'sentimentAtEnd'">
                  <div class="table-data">
                    <div [ngClass]="{
                        'auto-answer-positive': row[col.prop] === 'Positive',
                        'auto-answer-negative': row[col.prop] === 'Negative',
                        'auto-answer-neutral': row[col.prop] === 'Neutral'
                      }">
                      {{ row[col.prop] }}
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="col.prop === 'summary'">
                  <div class="table-data" [matTooltip]="isEllipsisActive(textElement) ? row[col.prop] : ''"
                    [matTooltipClass]="'custom-tooltip'" [matTooltipPosition]="'below'">
                    <div class="ellipsis-text" #textElement>{{ row[col.prop] }}</div>
                  </div>
                </ng-container>
                <ng-container
                  *ngIf="!['topics', 'topicCluster', 'topicsClustered', 'sentimentAtStart', 'sentimentAtEnd', 'summary'].includes(col.prop)">
                  <div class="table-data" [matTooltip]="isEllipsisActive(textElement) ? row[col.prop] : ''"
                    [matTooltipClass]="'custom-tooltip'" [matTooltipPosition]="'below'">
                    <div class="ellipsis-text" #textElement>{{ row[col.prop] }}</div>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-footer *ngIf="true">
          <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize"
            let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset">
            <div class="row-count">
              <div>{{ rowCount }} records</div>
            </div>
          </ng-template>
        </ngx-datatable-footer>
      </ngx-datatable>
    </div>
  </div>
  } @else if (playgroundService.playgroundResultStatus === 'inProgress') {
  <div class="playground-animation-wrapper">
    <div class="playground-animation-container">
      <div class="animation-title">
        <img src="../../../../../assets/icons/processing.svg" alt="animation">
        <span>Processing transcripts...</span>
      </div>
      <div class="animation-description">
        <span>This may take some time. <br>
          We'll notify you when it's ready!</span>
      </div>
    </div>
  </div>
  } @else if (playgroundService.playgroundResultStatus === 'noData') {
  <div class="playground-animation-wrapper">
    <div class="playground-animation-container">
      <div class="animation-title">
        <span>No Data Found</span>
      </div>
      <div class="animation-description">
        <span>No insights were generated for the provided input.</span>
      </div>
    </div>
  </div>
  } @else if (playgroundService.playgroundResultStatus === 'error') {
  <div class="playground-animation-wrapper">
    <div class="playground-animation-container">
      <div class="animation-title">
        <span>Error Occurred</span>
      </div>
      <div class="animation-description">
        <span>An error occurred while processing your request. Please try again.</span>
      </div>
    </div>
  </div>
  }
</div>
